"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-practice-logo-text.svg.js",
    _path,
    _path2,
    _path3,
    _path4,
    _path5;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 219,
    height: 60,
    viewBox: "0 0 219 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M76 22.352v-9.48h2.208v1.355c.392-.922 1.337-1.543 2.525-1.543 1.28 0 2.153.545 2.617 1.655.538-1.11 1.558-1.655 3.062-1.655 2.06 0 3.248 1.449 3.248 3.8v5.867h-2.23v-5.547c0-1.297-.612-2.107-1.67-2.107-1.095 0-1.856.903-1.856 2.2v5.455h-2.206v-5.548c0-1.297-.612-2.107-1.67-2.107-1.04 0-1.82.922-1.82 2.2v5.455H76zm18.077.13l-3.84-9.611h2.281l2.728 6.92 2.803-6.918h2.283L94.838 26h-2.264l1.503-3.518zm38.42-12.012c-.975-.904-2.36-1.382-4.009-1.382h-3.126v13.335h2.212v-3.066h.914c1.649 0 3.034-.475 4.008-1.372.984-.908 1.504-2.205 1.504-3.745 0-1.553-.52-2.857-1.503-3.77zm-4.923.733h.843c2.213 0 3.336 1.022 3.336 3.037 0 1.991-1.123 3-3.336 3h-.843v-6.037zm-21.02 3.496l-.977-.469c-1.461-.695-1.828-.982-1.828-1.818 0-.789.587-1.319 1.462-1.319.904 0 1.485.325 1.946 1.094l.28.465 1.778-1.153-.273-.447C108.1 9.672 106.874 9 105.192 9c-2.105 0-3.633 1.45-3.633 3.448 0 1.95 1.182 2.903 3.089 3.81l.98.469c1.525.717 1.966 1.2 1.966 2.16 0 .983-.786 1.57-2.1 1.57-1.184 0-2.141-.584-2.693-1.64l-.247-.47-1.908 1.016.247.473c.927 1.772 2.567 2.748 4.619 2.748 1.273 0 2.346-.343 3.103-.99.776-.666 1.187-1.614 1.187-2.745 0-2.145-1.242-3.182-3.248-4.15zm15.505 3.523l-.306.416c-.881 1.19-2.153 1.819-3.678 1.819-2.575 0-4.443-1.962-4.443-4.664 0-2.66 1.872-4.663 4.351-4.663 1.45 0 2.611.558 3.453 1.663l.315.41 1.739-1.27-.328-.436c-1.228-1.632-3.012-2.494-5.158-2.494-3.781 0-6.633 2.918-6.633 6.79-.009 1.872.663 3.592 1.893 4.844 1.23 1.252 2.931 1.951 4.775 1.951 2.299 0 4.136-.894 5.46-2.658l.331-.44-1.771-1.268z",
    fill: "#878787",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M81.408 32.208c2.687 0 4.75.477 6.188 1.43 1.439.936 2.158 2.479 2.158 4.628 0 2.167-.728 3.735-2.184 4.706-1.456.953-3.536 1.43-6.24 1.43h-1.274v6.032H76V32.676c.884-.173 1.82-.295 2.808-.364.988-.07 1.855-.104 2.6-.104zm.26 3.458c-.295 0-.59.009-.884.026-.277.017-.52.035-.728.052v5.2h1.274c1.404 0 2.461-.19 3.172-.572.71-.381 1.066-1.092 1.066-2.132 0-.503-.095-.919-.286-1.248a1.88 1.88 0 00-.78-.78c-.33-.208-.737-.347-1.222-.416a9.198 9.198 0 00-1.612-.13zM100.61 32.208c2.704 0 4.776.485 6.214 1.456 1.439.953 2.158 2.444 2.158 4.472 0 1.265-.294 2.297-.884 3.094-.572.78-1.404 1.395-2.496 1.846.364.45.746.97 1.144 1.56.399.572.789 1.179 1.17 1.82.399.624.78 1.283 1.144 1.976.364.676.702 1.343 1.014 2.002h-4.55c-.329-.59-.667-1.187-1.014-1.794a29.373 29.373 0 00-1.04-1.768 31.929 31.929 0 00-1.04-1.612 16.22 16.22 0 00-1.04-1.404h-2.002v6.578h-4.056V32.676a23.013 23.013 0 012.73-.364c.954-.07 1.803-.104 2.548-.104zm.234 3.458c-.294 0-.563.009-.806.026l-.65.052v4.888h1.144c1.526 0 2.618-.19 3.276-.572.659-.381.988-1.031.988-1.95 0-.884-.338-1.508-1.014-1.872-.658-.381-1.638-.572-2.938-.572zM128.151 50.434a36.94 36.94 0 00-.65-1.924l-.676-1.976h-7.02c-.226.659-.46 1.317-.702 1.976-.226.659-.434 1.3-.624 1.924h-4.212a317.942 317.942 0 011.924-5.382 229.704 229.704 0 011.768-4.654 234.95 234.95 0 011.716-4.134 98.424 98.424 0 011.768-3.848h3.874c.589 1.248 1.17 2.53 1.742 3.848.572 1.3 1.144 2.678 1.716 4.134a159.993 159.993 0 011.794 4.654c.606 1.647 1.248 3.44 1.924 5.382h-4.342zm-4.862-13.936c-.087.26-.217.615-.39 1.066-.174.45-.373.97-.598 1.56-.226.59-.477 1.24-.754 1.95-.26.71-.529 1.456-.806 2.236h5.122c-.278-.78-.546-1.525-.806-2.236-.26-.71-.512-1.36-.754-1.95l-.598-1.56c-.174-.45-.312-.806-.416-1.066zM144.981 50.798c-2.929 0-5.165-.815-6.708-2.444-1.525-1.63-2.288-3.943-2.288-6.942 0-1.49.234-2.817.702-3.978.468-1.179 1.109-2.167 1.924-2.964a7.959 7.959 0 012.912-1.846c1.127-.416 2.349-.624 3.666-.624.763 0 1.456.06 2.08.182.624.104 1.17.234 1.638.39.468.139.858.286 1.17.442.312.156.537.277.676.364l-1.17 3.276a9.755 9.755 0 00-1.95-.754c-.728-.208-1.56-.312-2.496-.312-.624 0-1.239.104-1.846.312a4.208 4.208 0 00-1.586 1.014c-.451.45-.815 1.04-1.092 1.768-.277.728-.416 1.612-.416 2.652 0 .832.087 1.612.26 2.34.191.71.485 1.326.884 1.846.416.52.953.936 1.612 1.248.659.295 1.456.442 2.392.442.589 0 1.118-.035 1.586-.104.468-.07.884-.147 1.248-.234.364-.104.685-.217.962-.338.277-.121.529-.234.754-.338l1.118 3.25c-.572.347-1.378.659-2.418.936-1.04.277-2.245.416-3.614.416zM170.147 32.416v3.458h-5.434v14.56h-4.056v-14.56h-5.434v-3.458h14.924zM175.354 32.416h4.056v18.018h-4.056V32.416zM194.396 50.798c-2.929 0-5.165-.815-6.708-2.444-1.525-1.63-2.288-3.943-2.288-6.942 0-1.49.234-2.817.702-3.978.468-1.179 1.109-2.167 1.924-2.964a7.959 7.959 0 012.912-1.846c1.127-.416 2.349-.624 3.666-.624.763 0 1.456.06 2.08.182.624.104 1.17.234 1.638.39.468.139.858.286 1.17.442.312.156.537.277.676.364l-1.17 3.276a9.755 9.755 0 00-1.95-.754c-.728-.208-1.56-.312-2.496-.312-.624 0-1.239.104-1.846.312a4.208 4.208 0 00-1.586 1.014c-.451.45-.815 1.04-1.092 1.768-.277.728-.416 1.612-.416 2.652 0 .832.087 1.612.26 2.34.191.71.485 1.326.884 1.846.416.52.953.936 1.612 1.248.659.295 1.456.442 2.392.442.589 0 1.118-.035 1.586-.104.468-.07.884-.147 1.248-.234.364-.104.685-.217.962-.338.277-.121.529-.234.754-.338l1.118 3.25c-.572.347-1.378.659-2.418.936-1.04.277-2.245.416-3.614.416zM205.639 50.434V32.416h12.168v3.406h-8.112v3.536h7.202v3.328h-7.202v4.342h8.71v3.406h-12.766z",
    fill: "#2A2A2A",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.537 20.37L56.61 52.307H3.927L1 20.371h58.537zM33.195 27.63h-5.854v5.806h-5.853v5.807l5.853-.001v5.807h5.854v-5.807h5.854v-5.806h-5.854v-5.806z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 18.917h58.537l-5.854-2.901H6.853L1 18.916zM21.488 9.484l2.07 2.903v2.18l-2.07-.006V9.484zm17.56 0v5.077h-2.043v-2.18l2.044-2.897z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.488 8h17.56l-2.07 2.903H23.544L21.488 8z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;